// extracted by mini-css-extract-plugin
module.exports = {"error":"R_cc"};